import { AppEventDispatcherContext } from './Provider';
import { useContext } from 'react';

export default function useAppEventDispatcher() {
  return useContext(AppEventDispatcherContext);
}
